<template>
  <el-button size="mini" type="primary" plain @click="onSubmit">
    Publish
  </el-button>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
  props: {
    articleId: String,
  },
  methods: {
    async onSubmit() {
      this.loading = true
      try {
        var { data } = await this.$http.put(`/articles/${ this.articleId }/status`, {})
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.$emit('update')
      this.$message.success(data.message)
    },
  }
}
</script>
